import { render, staticRenderFns } from "./CreateIncomeStatement.vue?vue&type=template&id=7646ab99"
import script from "./CreateIncomeStatement.vue?vue&type=script&lang=js"
export * from "./CreateIncomeStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports